const libraries = [
  {
    id: 1,
    series: '1000 SERIES',
    product: 'Blade Tray C-4 Trim',
    link: 'https://drive.google.com/file/d/1V8TnbM5m-BwfaLsR_gXl9vAXCh0xpMw0/view',
  },
  {
    id: 2,
    series: '1500 SERIES',
    product: 'Blade Tray C-18 Trim',
    link: 'https://drive.google.com/file/d/1Rh7PrXvw7p5ovWRTcA3AVffFDgfC8oID/view',
  },
  {
    id: 3,
    series: '2000 SERIES',
    product: 'Box Tray C-4 Trim',
    link: 'https://drive.google.com/file/d/1xVBYM68pHaUDEri3jJhY-MARSKsnqcMt/view',
  },
  {
    id: 4,
    series: '2500 SERIES',
    product: 'Box Tray C-18 Trim',
    link: 'https://drive.google.com/file/d/1m8DqGsOXSLsgJ-EeIFF8aqVRWEG-YUlt/view',
  },
  {
    id: 5,
    series: 'FHS SERIES',
    product: 'Full Height Slider Series',
    link: 'https://drive.google.com/file/d/1GQ6SQLu5KnJv-gwuk7FXaytriTeX4rq_/view',
  },
  {
    id: 6,
    series: 'HSS SERIES',
    product: 'Horizontal Surface Mount Slider',
    link: 'https://drive.google.com/file/d/1zO8cAHqqAWc8wGS2Xsq4g8weAD7LZtN_/view',
  },
  {
    id: 7,
    series: 'TWS SERIES',
    product: 'Teaching Wall Sliders',
    link: 'https://drive.google.com/file/d/1lQ8JOw5iGvry5Wr4Kt9fwhvD5sngMFo_/view',
  },
  {
    id: 8,
    series: 'VFM SERIES',
    product: 'Vertical Floor Mounted',
    link: 'https://drive.google.com/file/d/10VOfCwZcGFi22tmAa68WSEtB-Xw5yJKJ/view',
  },
  {
    id: 9,
    series: 'VWM SERIES',
    product: 'Vertical Wall Mounted',
    link: 'https://drive.google.com/file/d/13ZjvMX1r5tJ08vzvEEUcXmdQiR1OeFMO/view',
  },
  {
    id: 10,
    series: 'FDW SERIES',
    product: 'Forbo Directly To Wall',
    link: 'https://drive.google.com/file/d/1WshQ7m2pzACf4dtIBPFRuMty3s995Awv/view',
  },
  {
    id: 11,
    series: 'TWP SERIES',
    product: 'Tackwall Panels',
    link: 'https://drive.google.com/file/d/1KdbY6g4H5c7NwHzI2-qT0GH2woawRY_0/view?usp=drive_open',
  },
  {
    id: 12,
    series: 'HDC SERIES',
    product: 'Hinged Display Cases',
    link: 'https://drive.google.com/file/d/1KG7R2JseWmZIDCHNpld8HSzDhSMH8Ncc/view',
  },
  {
    id: 13,
    series: 'SDC SERIES',
    product: 'Sliding Display Cases',
    link: 'https://drive.google.com/file/d/1j2zr1NwJ_8gP84-wvZBS-a1Pt29ZRCG9/view',
  },
];

const tnb = [
  {
    id: 1,
    series: 'DRM-3TB',
    product: 'Singles',
    link: 'https://drive.google.com/file/d/19IDVft8NkUlcyH_4aBuzyw7knIPiNUCk/view?usp=drive_open',
  },
  {
    id: 2,
    series: 'DRM-6TB',
    product: 'Doubles',
    link: 'https://drive.google.com/file/d/15T07GwsetHvKho1qiO5rgqnl5gcSkNNj/view?usp=drive_open',
  },
  {
    id: 3,
    series: 'DRM-9TB',
    product: 'Triples',
    link: 'https://drive.google.com/file/d/1zUukaAFgnRWbtPOgjrQu2uZSTCzfaCd5/view',
  },
  {
    id: 4,
    series: 'DRM-12TB',
    product: 'Quads',
    link: 'https://drive.google.com/file/d/11aXIEFYJWFKZNdIs5kx3w5758XP3P5gi/view',
  },
  {
    id: 5,
    series: 'DSM-3TB',
    product: 'Singles',
    link: 'https://drive.google.com/file/d/1-vEfeHbt_ksvm4OSp7Ftyx0-lLJKDVpB/view',
  },
  {
    id: 6,
    series: 'DSM-6TB',
    product: 'Doubles',
    link: 'https://drive.google.com/file/d/1PB4qxiCv7357KI0G9wZfwJ8k8ITi-l3o/view',
  },
  {
    id: 7,
    series: 'DSM-9TB',
    product: 'Triples',
    link: 'https://drive.google.com/file/d/1ejBHBeG6wgcw0wTE6kRICV_yHSL4rqcz/view',
  },
  {
    id: 8,
    series: 'DSM-12TB',
    product: 'Quads',
    link: 'https://drive.google.com/file/d/18QWI-MZy-dJuxgoA-3LxGL-vMzhMOuEg/view',
  },
];

const instruction1 = [
  {
    id: 1,
    series: 'BOARDS',
    product: 'Box Tray Only',
    link: 'https://drive.google.com/file/d/16Nk33IQ3ZADm3ycFc-wMnKQJZLg1uWW6/view',
  },
  {
    id: 2,
    series: 'BOARDS',
    product: 'Blade Tray and Box Tray',
    link: 'https://drive.google.com/file/d/1k08TLqBOzX1XdceUkhl7Lc0okuVmMkDr/view',
  },
  {
    id: 3,
    series: 'FHS SERIES',
    product: 'Full Height Slider Series',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/FHS_INSTALLATION_INSTRUCTIONS.pdf?8846400396684957288',
  },
  {
    id: 4,
    series: 'HSS SERIES',
    product: 'Horizontal Surface Mount Sliders',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/HSS_-_INSTALLATION_INSTRUCTIONS-Model.pdf?14361471995195906541',
  },
  {
    id: 5,
    series: 'TWS SERIES',
    product: 'Teaching Wall Sliders',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/TWS_-_TEACHING_WALLS_INSTALLATION_INSTRUCTIONS.pdf?16275563692180196013',
  },
  {
    id: 6,
    series: 'VFM SERIES',
    product: 'Vertical Floor Mounted',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/VWM_VFM_-_VERTICAL_SLIDER_INSTALL_INSTRUCTIONS.pdf?13475522443184767888',
  },
];
const instruction2 = [
  {
    id: 1,
    series: 'VWM SERIES',
    product: 'Vertical Wall Mounted',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/VWM_VFM_-_VERTICAL_SLIDER_INSTALL_INSTRUCTIONS.pdf?13475522443184767888',
  },
  {
    id: 2,
    series: 'FDW SERIES',
    product: 'Forbo Directly To Wall',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/FDW_INSTALLATION_INSTRUCTIONS.pdf?6252265329334587449',
  },
  {
    id: 3,
    series: 'TWP SERIES',
    product: 'Tackwall Panels',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/TWP_INSTALLATION_INSTRUCTIONS_WITH_NO_J-TRIM.pdf?v=1604076873',
  },
  {
    id: 4,
    series: 'TWP-NT SERIES',
    product: 'Tackwall Panels',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/TWP_INSTALLATION_INSTRUCTIONS_WITH_NO_J-TRIM.pdf?v=1604076873',
  },
  {
    id: 5,
    series: 'HDC SERIES',
    product: 'Hinged Display Cases',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/SDC_HDC_-_INSTALLATION_INSTRUCTIONS.pdf?9774202643507987770',
  },
  {
    id: 6,
    series: 'SDC SERIES',
    product: 'Sliding Display Cases',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/SDC_HDC_-_INSTALLATION_INSTRUCTIONS.pdf?9774202643507987770',
  },
  {
    id: 7,
    series: 'FHW SERIES',
    product: 'Installation with Divider Bar',
    link: 'https://drive.google.com/open?id=14-bALoVIz11_MYpzLGmjx1RVX3uDxA-F',
  },
  {
    id: 8,
    series: 'Other Methods of installation',
    product: '',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/BLADE_TRAY_CLIPLESS_INSTALLATION_INSTRUCTIONS.pdf?14360855924186261655',
  },
];
const instruction3 = [
  {
    id: 1,
    series: 'DRM-3TB',
    product: 'Singles',
    link: 'https://drive.google.com/file/d/1vtVtlxXurf0jlCoWJoMltqP-v_h3XtiV/view',
  },
  {
    id: 2,
    series: 'DRM-6TB',
    product: 'Doubles',
    link: 'https://drive.google.com/file/d/1HGemfkvEEMd3vtjxuCmcp_R8sn1m5ydI/view',
  },
  {
    id: 3,
    series: 'DRM-9TB',
    product: 'Triples',
    link: 'https://drive.google.com/file/d/1gi8YWX_-aeq8yukij9PF8s6C1nubsrKd/view',
  },
  {
    id: 4,
    series: 'DRM-12TB',
    product: 'Quads',
    link: 'https://drive.google.com/file/d/1lXtPHL4oMjinBJ10_NoxNRZnNOnSm7fD/view',
  },
  {
    id: 5,
    series: 'DSM-3TB',
    product: 'Singles',
    link: 'https://drive.google.com/file/d/1Qckj8pt6dr9C0kQh3TiVdRDgFPZ-LzLR/view',
  },
  {
    id: 6,
    series: 'DSM-6TB',
    product: 'Doubles',
    link: 'https://drive.google.com/file/d/11af8nPfDfrgwb70TkcJ8plpduwY-gqFX/view',
  },
  {
    id: 7,
    series: 'DSM-9TB',
    product: 'Triples',
    link: 'https://drive.google.com/file/d/1wu1tR7A8Km7AnMFtQsdFSnrEiw2jl8bn/view',
  },
  {
    id: 8,
    series: 'DSM-12TB',
    product: 'Quads',
    link: 'https://drive.google.com/file/d/1DXMB4ntk3G5wDDkTFveB72WOOw72g_Yk/view',
  },
];

const prodData = [
  {
    id: 1,
    series: '1000 SERIES',
    product: 'Blade Tray C-4 Trim',
    link: 'https://drive.google.com/file/d/1_oJqqwg1iDURNymj068QXa6Dw16MGr2U/view?usp=sharing',
  },
  {
    id: 2,
    series: '1500 SERIES',
    product: 'Blade Tray C-18 Trim',
    link: 'https://drive.google.com/file/d/17RC8DLjHhcd04HzzW5at0AxxUAEZw3rG/view?usp=sharing',
  },
  {
    id: 3,
    series: '2000 SERIES',
    product: 'Box Tray C-4 Trim',
    link: 'https://drive.google.com/file/d/1uzaCgY0-LRblNfYKmAjlqa6bRDNCdoZE/view?usp=sharing',
  },
  {
    id: 4,
    series: '2500 SERIES',
    product: 'Box Tray C-18 Trim',
    link: 'https://drive.google.com/file/d/1ZaixFcNTu9SkvizHgeNX6fIoTZez69DY/view?usp=sharing',
  },
  {
    id: 5,
    series: '3000 SERIES',
    product: 'Premium Box Tray C-4 Trim',
    link: 'https://drive.google.com/file/d/1m4hZnMAgqlIt0exdiaBP9kjOrjq5E5Pr/view?usp=sharing',
  },
  {
    id: 6,
    series: '3500 SERIES',
    product: 'Premium Box Tray C-18 Trim',
    link: 'https://drive.google.com/file/d/1LNV4OldRzv-I2j9_f7cgygu1VPyCpwYC/view?usp=sharing',
  },

  {
    id: 7,
    series: 'MW SERIES',
    product: 'Marker Wall',
    link: 'https://drive.google.com/file/d/1UWrMzqXtrbce9iTRBXBbJko_4XSQzmj8/view?usp=sharing',
  },
  {
    id: 8,
    series: 'HSS SERIES',
    product: 'Horizontal Surface Mount Slider',
    link: 'https://drive.google.com/file/d/1za_5RePVLBmggDEI-yH5ELSTgdoHjZ86/view?usp=sharing',
  },
  {
    id: 9,
    series: 'TWS SERIES',
    product: 'Teaching Wall Sliders',
    link: 'https://drive.google.com/file/d/16i00Z9cuIvcZ1iEpA84Ag94znjM66Ox2/view?usp=sharing',
  },
  {
    id: 10,
    series: 'VFM SERIES',
    product: 'Vertical Floor Mounted',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_02_VERTICAL_SLIDERS_SPECS.pdf?10732015493973233362',
  },
  {
    id: 11,
    series: 'VWM SERIES',
    product: 'Vertical Wall Mounted',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_02_VERTICAL_SLIDERS_SPECS.pdf?10732015493973233362',
  },
  {
    id: 12,
    series: 'FDW SERIES',
    product: 'Forbo Directly To Wall',
    link: 'https://drive.google.com/file/d/1vdmR1wQAc-mHlgjKx15mEIcLngm1P4Fy/view?usp=sharing',
  },
  {
    id: 13,
    series: 'TWP SERIES',
    product: 'Tackwall Panels',
    link: 'https://drive.google.com/file/d/1Dpveq-qa5f85NIqnycm-TEuKrECW9L7L/view?usp=sharing',
  },
  {
    id: 14,
    series: 'HDC SERIES',
    product: 'Hinged Display Cases',
    link: 'https://drive.google.com/file/d/1JZMGVdbN1VmB4WzXxVfOFDSxnO7iLrb8/view?usp=sharing',
  },
  {
  id: 15,
  series: 'SDC SERIES',
  product: 'Sliding Display Cases',
  link: 'https://drive.google.com/file/d/1v23WxhyJlmUg_owO_2mQeivsjr2u2ysC/view?usp=sharing',
  },
  {
    id: 16,
    series: 'TKS SERIES',
    product: 'Tackstrips Display Rails',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/TKS_-_PRODUCT_DATA.pdf?723',
  },
];

const specifications = [
  {
    id: 1,
    series: '1000 SERIES',
    product: 'Blade Tray C-4 Trim',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_00_VISUAL_DISPLAY_SURFACES_BLADE_TRAY.pdf?7518332774779798866',
  },
  {
    id: 2,
    series: '1500 SERIES',
    product: 'Blade Tray C-18 Trim',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_00_VISUAL_DISPLAY_SURFACES_BLADE_WIDE_TRIM_SPECS.pdf?3313453076253175497',
  },
  {
    id: 3,
    series: '2000 SERIES',
    product: 'Box Tray C-4 Trim',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_00_VISUAL_DISPLAY_SURFACES_BOX_TRAY.pdf?2616217033573381970',
  },
  {
    id: 4,
    series: '2500 SERIES',
    product: 'Box Tray C-18 Trim',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_00_VISUAL_DISPLAY_SURFACES_BOX_WIDE_TRIM_SPECS.pdf?2616217033573381970',
  },
  {
    id: 5,
    series: 'FHS SERIES',
    product: 'Full Height Slider',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_00_VISUAL_DISPLAY_SURACES_FULL_HEIGHT_SPECS.pdf?13411136459302460173',
  },
  {
    id: 6,
    series: 'HSS SERIES',
    product: 'Horizontal Surface Mount Slider',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_01_HORIZONTAL_SLIDERS_SPECS.pdf?7080386336206342601',
  },
  {
    id: 7,
    series: 'TWS SERIES',
    product: 'Teaching Wall Sliders',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_01_HORIZONTAL_SLIDERS_SPECS.pdf?7080386336206342601',
  },
  {
    id: 9,
    series: 'VFM SERIES',
    product: 'Vertical Floor Mounted',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_02_VERTICAL_SLIDERS_SPECS.pdf?10732015493973233362',
  },
  {
    id: 10,
    series: 'VWM SERIES',
    product: 'Vertical Wall Mounted',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_11_02_VERTICAL_SLIDERS_SPECS.pdf?10732015493973233362',
  },
  {
    id: 11,
    series: 'FDW SERIES',
    product: 'Forbo Directly To Wall',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/Forbo_Colorex_Specifications.pdf?313024491549903149',
  },
  {
    id: 12,
    series: 'TWP SERIES',
    product: 'Tackwall Panels',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/00_92_50_TACKWALL_PANELS.pdf?12634582884215318460',
  },
  {
    id: 13,
    series: 'HDC SERIES',
    product: 'Hinged Display Cases',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_12_10_DISPLAY_CASES.pdf?4460534555611783279',
  },
  {
    id: 14,
    series: 'SDC SERIES',
    product: 'Sliding Display Cases',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/10_12_10_DISPLAY_CASES.pdf?4460534555611783279',
  },
  {
    id: 15,
    series: 'D-SERIES',
    product: 'Tables & Benches',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/TABLES_BENCHES_SPECIFICATIONS.pdf?v=1597092044',
  },
  {
    id: 16,
    series: 'D-SERIES',
    product: 'Tables & Benches Word Format',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/T_B_SPECS_12640.docx?v=1597686329',
  },
  {
    id: 17,
    series: 'FHW SERIES',
    product: 'Full Height Writing Walls',
    link: 'https://drive.google.com/open?id=1sg3yYjY3uFukoEz8lqTyeLQf91Gc1hL6',
  },
];

const colorCards = [
  {
    id: 1,
    series: 'NACO',
    product: 'e3 Procelain',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/NACO_e3_porcelain.pdf?11283972242225078647',
  },
  {
    id: 2,
    series: 'NACO',
    product: 'e3 Forbo',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/NACO_Forbo.pdf?11283972242225078647',
  },
  {
    id: 3,
    series: 'NACO',
    product: 'Fabric',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/NACO_FR701_NEWEST.pdf?975775358675742702',
  },
  {
    id: 4,
    series: 'NACO',
    product: 'Natural Cork Data',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/NACO_Natural_Cork_Data.pdf?6009422613487265829',
  },
  {
    id: 5,
    series: 'NACO',
    product: 'Powder Coat',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/NACO_POWDERCOAT.pdf?6009422613487265829',
  },
  {
    id: 6,
    series: 'NACO',
    product: 'Standard Vinyls',
    link: 'https://cdn.shopify.com/s/files/1/0046/6544/2397/files/NACO_STANDARD_VINYLS.pdf?6009422613487265829',
  },
  {
    id: 7,
    series: 'NACO',
    product: 'Laminate ',
    link: 'https://drive.google.com/file/d/1Mf4DXvP6n_Kobg4OPy2RXPFqPlcjtsiK/view',
  },
];

export {
  libraries,
  tnb,
  instruction1,
  instruction2,
  instruction3,
  prodData,
  specifications,
  colorCards,
};
